import { render, staticRenderFns } from "./number-unit.vue?vue&type=template&id=4e2468ca&scoped=true"
import script from "./number-unit.vue?vue&type=script&lang=ts"
export * from "./number-unit.vue?vue&type=script&lang=ts"
import style0 from "./number-unit.vue?vue&type=style&index=0&id=4e2468ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2468ca",
  null
  
)

export default component.exports